import { type HotelBookingRoomOption } from "@/app/lib/types/types";
import { formatCurrency } from "@/app/lib/utils/currency";
import { HotelRoomTitle } from "./HotelRoomTitle";
import { usePaymentContext } from "@/app/lib/context/PaymentContext";
import { useTranslations } from "use-intl";
import { includeBnplFee } from "@/app/lib/utils/bnpl-fee";
import { Image } from "../Image";

export const HotelRoom = ({
  room,
  adultCount,
  childrenCount,
}: {
  room: HotelBookingRoomOption;
  adultCount: number;
  childrenCount: number;
}) => {
  const { paymentType, selectedInstallments } = usePaymentContext();
  const t = useTranslations();
  const roomImage = room.images?.[0];

  const payLaterPrice = includeBnplFee(room.price?.value || 0);
  return (
    <div className="flex w-full justify-between gap-4 rounded-2xl bg-[#F3F4F7] p-3">
      <div className="text-sm font-medium">
        <div className="mb-2">
          <HotelRoomTitle
            name={room.name}
            board={room.board}
            occupancy={{
              numberOfAdults: adultCount,
              numberOfChildren: childrenCount,
            }}
          />
        </div>
        <div className="font-bold">
          <span>
            {formatCurrency(
              paymentType === "bnpl"
                ? payLaterPrice / selectedInstallments
                : room.price?.value,
              room.price?.currency,
            )}
          </span>
          {paymentType === "bnpl" && <span> {t("payment.perMonth")}</span>}
        </div>
      </div>

      {roomImage ? (
        <div className="relative h-[48px] w-[60px] overflow-clip rounded-lg">
          <Image
            className="h-full w-full object-cover"
            src={roomImage.url}
            alt={roomImage.name}
          />
        </div>
      ) : null}
    </div>
  );
};
